import { PDF_TYPES } from 'teacher-ui-client/components/printables/pdf-types'
import type { PrintablesBookRole } from 'teacher-ui-client/components/printables/roles'
import type {
  PrintablesLibrarySetEntry,
  PrintablesLibraryBookEntry,
} from 'teacher-ui-client/contentful-client/entry-types'

export function printablesPerBook(book?: PrintablesLibraryBookEntry) {
  return book ? PDF_TYPES.filter((mediaType) => book.fields[mediaType]).length : 0
}

export function printablesForRole(role: PrintablesBookRole, printablesBookSet?: PrintablesLibrarySetEntry) {
  return printablesBookSet?.fields.books.find((entry) => entry?.fields.role === role)
}

export default { printablesPerBook, printablesForRole }
